import AsoHeader from "../../../components/Aso/Header";
import AsoFaturamentoMensalEmpresa from "../../../components/Aso/Register/AsoFaturamentoMensalEmpresa";

const AsoRegistroFaturamentoMensalEmpresa = () => {
    return (
        <>
            <AsoHeader />
            <AsoFaturamentoMensalEmpresa />
        </>
    );
}

export default AsoRegistroFaturamentoMensalEmpresa;